import store from '../../store'

export function uploadFinished(uploadId) {
	store.dispatch({ type: 'FINISH_UPLOAD', uploadId })
}


